import React, {Component} from 'react';
import {withRouteData} from 'react-static';
import styled from 'styled-components';

import features1 from '../resources/images/features-1.png';
import features2 from '../resources/images/features-2.png';
import features3 from '../resources/images/features-3.png';

const FeaturesStyle = styled.div`
  margin-bottom: 1.875rem;
  position: relative;

  h2 {
    margin-bottom: 7.5rem;
    text-shadow: 0 0 2px #83F5F8;
    color: #83F5F8;
  }

  h3 {
    margin-bottom: 0.625rem;
    font-size: 1.25rem;
    color: #83F5F8;
  }

  p {
    opacity: 0.5;
    margin-top: 0;
    margin-bottom: 1.25rem;
    @media screen and (max-width: 39.9375em) {
	    width: 75%;
        margin-left: auto;
        margin-right: auto;
    }
  }

.features-itemIcon {
  margin-bottom: 1.875rem;
  height: 4.875rem;
  display: inline-block;
  position: relative;
}

.features-item {
  margin-bottom: 60px;
}

.features-more {
  /* LEARN MORE: */
  font-weight: 500;
  font-size: 1rem;
  color: #83F5F8;
  text-transform: uppercase;
}

`;

class Features extends Component {
	render() {
		return (
			<FeaturesStyle className="text-center">
				<div className="container">
					<div className="row">
						<div className="columns medium-4 small-12">
							<div className="features-item">
								<img className="features-itemIcon" src={features1} style={{top: "0.375rem"}} alt="Up to 5x cheaper icon" />
								<h3>{ this.props.features.featureCheap.fact }</h3>
								<p>{ this.props.features.featureCheap.description }</p>
							</div>
						</div>
						<div className="columns medium-4 small-12">
							<div className="features-item">
								<img className="features-itemIcon" src={features2} alt="Fully compatible icon" />
								<h3>{ this.props.features.featureCompatible.fact }</h3>
								<p>{ this.props.features.featureCompatible.description }</p>
							</div>
						</div>
						<div className="columns medium-4 small-12">
							<div className="features-item">
								<img className="features-itemIcon" src={features3} alt="Energy efficient icon" />
								<h3>{ this.props.features.featureEfficient.fact }</h3>
								<p>{ this.props.features.featureEfficient.description }</p>
							</div>
						</div>
					</div>
				</div>
			</FeaturesStyle>
		)
	}
}

export default withRouteData(Features)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Features.js